import React from "react";
import { component_tool } from "@/tool";
let { WizModal } = component_tool;
import { WizTableForm } from '@/containers/common';
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

//配置项
const componentName = "classStudentExam";
let ref;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "姓名",
    name: "fullName",
    dataIndex: "fullName",
    searchItem: {},
    tableItem: {},
    formItem: {}
  },
  {
    title: "账号",
    name: "userName",
    dataIndex: "userName",
    searchItem: {},
    tableItem: {},
    formItem: {}
  },
  {
    title: '手机号',
    name: 'mobile',
    tableItem: {}
  },
  {
    title: "组织名称",
    name: "orgIds",
    searchItem: {
      diy: WizTableForm,
      ...organizationConfig,
    }
  },
  {
    title: "岗位",
    name: "positionIds",
    searchItem: {
      diy: WizTableForm,
      ...positionConfig,
    }
  },
  {
    title: "组织名称",
    name: "orgName",
    dataIndex: "orgName",
    tableItem: {},
    formItem: {}
  },
  {
    title: "组织代码",
    name: "orgCode",
    dataIndex: "orgCode",
    tableItem: {},
    formItem: {}
  },
  {
    title: '岗位',
    name: 'positionName',
    tableItem: {},
    formItem: {}
  },
  {
    title: '任职状态',
    name: 'jobStateName',
    tableItem: {},
    formItem: {}
  },
  {
    title: "是否请假",
    name: "leaveState",
    dict: [
      { code: 0, codeName: "否" },
      { code: 1, codeName: "是" }
    ],
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: 'select'
    }
  },
  {
    title: "是否参加",
    name: "isExam",
    dataIndex: "isExam",
    searchItem: {
      type: "select"
    },
    tableItem: {},
    dict: [
      { code: true, codeName: "是" },
      { code: false, codeName: "否" }
    ],
    formItem: {
      type: "radio",
      initialValue: true
    }
  },
  {
    title: '成绩',
    name: 'scoreVal',
    tableItem: {},
    formItem: {}
  },
  {
    title: '通过状态',
    name: 'scoreState',
    tableItem: {},
    searchItem: {
      type: "select"
    },
    dict: [
      { code: 1, codeName: "通过" },
      { code: 0, codeName: "未通过" }
    ],
    formItem: {
      type: "radio",
      initialValue: 0
    }
  },
  // {
  //   title: '阅卷时间',
  //   name: 'examTime',
  //   tableItem: {},
  //   formItem: {}
  // }
];

const templateConfig = (date) => {
  const {onSelect,classInfoId,_btnLookUserFun,_this} = date;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  let initRows = () => {
    return _this.state.selectedClassResultRows
  };
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        btnAccessCheck:false,
        searchBarProps: {
          buttonSort: ['exportClassStudentExam','exportStudentExamByAllIdentity'],
          buttons: [
            {
              key: 'exportClassStudentExam',
              custom: true,
              params: { icon: 'export', children: '按班级任职导出成绩', type:'primary',},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportClassStudentExam",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'exportStudentExamByAllIdentity',
              custom: true,
              params: { icon: 'export', children: '按任职情况导出成绩', type:'primary'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportStudentExamByAllIdentity",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
          onSelect: _onSelect
        },
        commonOperate: {
          update: true
        },
        // rowOperateSort: ['showUserIdentity',],
        // rowOperateView: [
        //   {
        //     key: "showUserIdentity",
        //     name: "WizButton",
        //     params: {  children: "查看已选任职",
        //       key: "_btn",
        //     },
        //     onClick: e => _btnLookUserFun && _btnLookUserFun(e),
        //   },
        // ]
      }
    }
  }
};



let reduxTemplateCofig = args => {
  const { classInfoId ,examId} = args;
  const apis = {
    list: {
      path: `${componentName}/queryStudentExamPage`,
      payload: {
        key: `${componentName}@queryStudentExamPage`,
        apiParams: { classInfoId: classInfoId,examId: examId}
      }
    },
    exportClassStudentExam: {
      path: `${componentName}/exportStudentExamByCondition`,
      payload: {
        key: `${componentName}@exportStudentExamByCondition`,
        apiParams: { classInfoId: classInfoId,examId: examId}
      }
    },
    exportStudentExamByAllIdentity:{
      path: `${componentName}/exportStudentExamByAllIdentity`,
      payload: {
        key: `${componentName}@exportStudentExamByAllIdentity`,
        apiParams: { classInfoId: classInfoId,examId: examId}
      }
    }
  };

  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    keepInitApiParams: true,
    needLoading: false,
    ...args
  };
};

export { reduxTemplateCofig, templateConfig };
